module.exports = __webpack_public_path__ + "assets/icons/baseline-details-24px-c112.svg";